<template>
	<div class="footer_container">
		<div class="L1">
			<span>{{FooterMain.title}}</span>
			<!-- <span>严选 电脑专区</span> -->
		</div>
		<div class="L2">
			<div class="L2_div"><img :src="FooterMain.img" alt="" /></div>
		</div>
		<div class="L3">
			<div class="goods-card" v-for="(goods, index) in FooterSh" :key="goods.goods_id" @click="todetail(goods.goods_id)">
				<img :src="goods.imgurl" :alt="goods.title" class="goods-image">
				<div class="goods-info">
					<div class="goods-title">{{ formatTitle(goods.title) }}</div>
					<div class="goods-price">¥{{ goods.price }}/天</div>
				</div>
			</div>
		</div>
		<!-- <div style="width: 100%;height: 30px;"></div> -->
	</div>
</template>

<script>
	export default {
		name: "Footer",
		props: {
			FooterSh: {
				type: Array
			},
			FooterMain: {
				type: Object
			}
		},
		data() {
			return {

			}
		},
		computed: {
			L1Style(){
				if (!this.FooterMain.backgroundImg) {
				  return {};
				}
			}
			
		},
		mounted() {
			// 在 mounted 中调用方法
			// this.getfooter();
		},
		methods: {
			todetail(id){
				// const { id, activity_id } = item;
				this.$router.push({ name: "goods", query: { goods_id: id } })
			},
			getfooter() {
				// console.log(this.FooterMain);
				// console.log(this.FooterSh);

			},
			formatTitle(title) {
			      if (!title) return '';
			      return title.length > 10 ? title.substring(0, 11) + '...' : title;
			    }
		}
	}
</script>

<style scoped>
	.footer_container{
		width: 95%;
		margin: 0 auto;
		padding: 20px 10px 5px;
		margin-top: 15px;
		background: #FFFFFF;
		border-radius: 7.8px;
	}
	.L1{
		  background-image: url('https://txxzdata.galaxyemall.com/images/brand-title.png');
		  background-repeat: no-repeat;
		  background-position: center;
		  backgroundSize: cover;
		  text-align: center;
		  margin: 0 auto;


	}
	.L1 span{
		    font-size: 18.72px;
		    font-weight: 700;
	}
	.L2_div{
		margin: 10px 0;
	}
	.L2_div img{
		width: 100%;
		height: 114.4px;
		border-radius: 5.2px;
	}
	.L3{
		display: flex;
		justify-content: space-between;
		/* margin-bottom: 30px; */
	}
	
	
	.goods-card {
	  border-radius: 8px;
	  /* padding: 10px; */
	  /* border: 1px solid red; */
	  background: white;
	  width: 31%;
	}
	
	.goods-image {
	  width: 100%;
	  padding: 7.5px 11.5px;
	}
	
	.goods-title {
	  text-align: center;
	  font-size: 13.52px;
	  font-weight: 500;
	  line-height: 15.6px;
	  margin-bottom: 5.1px;
	}
	
	.goods-price {
	  font-size: 13.52px;
	  text-align: center;
	  color: red;
	  line-height: 20.8px;
	  /* margin-bottom: 5px; */
	}
	

	
</style>